import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FeatureFlags } from 'src/shared/enums/feature-flags.enum';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private flags: { [key in FeatureFlags]: boolean } = environment.featureFlags;

  constructor() {}

  isWorldlineEnabled(): boolean {
    return this.flags[FeatureFlags.WORLDLINE];
  }

  getAllFlags(): { [key in FeatureFlags]: boolean } {
    return this.flags;
  }
}